import { Avatar } from '@radix-ui/themes';
import { GameDataPlayerAvatar } from 'components/sections/game-data/players/avatar';
import { StringHelper } from 'lib_ts/classes/string.helper';
import { RadixAvatarSize, RadixColor } from 'lib_ts/enums/radix-ui';
import { IPitchList } from 'lib_ts/interfaces/pitches';

export const PitchListAvatar = (props: {
  list: IPitchList;
  fallbackColor?: RadixColor;
  size: RadixAvatarSize;
  loading?: boolean;
}) => {
  const { pitcher, name, mlb_repertoire } = props.list;
  const playerPk = mlb_repertoire?.playerPk;

  if (playerPk) {
    return (
      <GameDataPlayerAvatar
        playerPk={playerPk}
        size={props.size}
        name={pitcher || name}
        loading={props.loading}
      />
    );
  }

  return (
    <Avatar
      fallback={StringHelper.getInitials(name)}
      color={props.fallbackColor}
      style={{
        color: 'var(--accent-a11)',
      }}
      size={props.size}
    />
  );
};
